//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class Client {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    trEvent_CreateTrackingExport(trackExportDto?: TrackExportDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/V3/TrEvent/TrExport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(trackExportDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrEvent_CreateTrackingExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrEvent_CreateTrackingExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTrEvent_CreateTrackingExport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    trEvent_CreateTrackingExports(trackExportDtos?: (TrackExportDto | undefined)[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/V3/TrEvent/TrExports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(trackExportDtos);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrEvent_CreateTrackingExports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrEvent_CreateTrackingExports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTrEvent_CreateTrackingExports(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    trEvent_CreateLoginRequest(trackLoginRequestDto?: TrackLoginRequestDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/V3/TrEvent/TrLoginRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(trackLoginRequestDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrEvent_CreateLoginRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrEvent_CreateLoginRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTrEvent_CreateLoginRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    trEvent_CreateLoginSuccess(trackLoginSuccessDto?: TrackLoginSuccessDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/V3/TrEvent/TrLoginSuccess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(trackLoginSuccessDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrEvent_CreateLoginSuccess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrEvent_CreateLoginSuccess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTrEvent_CreateLoginSuccess(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    trEvent_CreateCatalogListing(trackCatalogListingDto?: TrackCatalogListingDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/V3/TrEvent/TrCatalogListing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(trackCatalogListingDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrEvent_CreateCatalogListing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrEvent_CreateCatalogListing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTrEvent_CreateCatalogListing(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    trEvent_CreateCatalogSuggestion(trackCatalogSuggestionDto?: TrackCatalogSuggestionDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/V3/TrEvent/TrCatalogSuggestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(trackCatalogSuggestionDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrEvent_CreateCatalogSuggestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrEvent_CreateCatalogSuggestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTrEvent_CreateCatalogSuggestion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    trEvent_CreateCatalog(trackCatalogDto?: TrackCatalogDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/V3/TrEvent/TrCatalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(trackCatalogDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrEvent_CreateCatalog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrEvent_CreateCatalog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTrEvent_CreateCatalog(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    trEvent_CreateCatalogItem(trackCatalogItemDto?: TrackCatalogItemDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/V3/TrEvent/TrCatalogItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(trackCatalogItemDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrEvent_CreateCatalogItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrEvent_CreateCatalogItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTrEvent_CreateCatalogItem(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    trEvent_CreateAttachment(trackAttachmentDto?: TrackAttachmentDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/V3/TrEvent/TrAttachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(trackAttachmentDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrEvent_CreateAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrEvent_CreateAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTrEvent_CreateAttachment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    trEvent_CreateCatalogSearch(trackSearchCatalogDto?: TrackSearchCatalogDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/V3/TrEvent/TrCatalogSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(trackSearchCatalogDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrEvent_CreateCatalogSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrEvent_CreateCatalogSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTrEvent_CreateCatalogSearch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    trEvent_CreateGlobalSearch(trackSearchGlobalDto?: TrackSearchGlobalDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/V3/TrEvent/TrGlobalSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(trackSearchGlobalDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrEvent_CreateGlobalSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrEvent_CreateGlobalSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTrEvent_CreateGlobalSearch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    trEvent_CreateContactFormOpen(trackContactFormOpenDto?: TrackContactFormOpenDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/V3/TrEvent/TrContactFormOpen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(trackContactFormOpenDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrEvent_CreateContactFormOpen(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrEvent_CreateContactFormOpen(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTrEvent_CreateContactFormOpen(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    trEvent_CreateContactFormSubmit(trackContactFormSubmitDto?: TrackContactFormSubmitDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/V3/TrEvent/TrContactFormSubmit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(trackContactFormSubmitDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrEvent_CreateContactFormSubmit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrEvent_CreateContactFormSubmit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTrEvent_CreateContactFormSubmit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    trEvent_CreateShareCatalogItem(trackShareCatalogItemDtoDto?: TrackShareCatalogItemDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/V3/TrEvent/TrShareCatalogItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(trackShareCatalogItemDtoDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrEvent_CreateShareCatalogItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrEvent_CreateShareCatalogItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTrEvent_CreateShareCatalogItem(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    trEvent_CreateCatalogExternal(trackCatalogExternal?: TrackCatalogExternalDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/V3/TrEvent/TrCatalogExternal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(trackCatalogExternal);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrEvent_CreateCatalogExternal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrEvent_CreateCatalogExternal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTrEvent_CreateCatalogExternal(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    trEvent_CreateLogoDownload(trackLogoDownload?: TrackLogoDownloadDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/V3/TrEvent/TrLogoDownload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(trackLogoDownload);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTrEvent_CreateLogoDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTrEvent_CreateLogoDownload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTrEvent_CreateLogoDownload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; };
}

export interface TrackBaseDto {
    interface?: InterfaceType;
    guid?: string;
    userId?: string | undefined;
    authenticatedUserId?: string | undefined;
    sessionId?: string | undefined;
    referrer?: string | undefined;
    userAgent?: string | undefined;
    hostAppUserAgent?: string | undefined;
    apiSessionId?: string | undefined;
    integrationKey?: string | undefined;
    applicationKey?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    trackTimestamp?: Date;
}

export interface TrackExportDto extends TrackBaseDto {
    catalogKey?: string | undefined;
    catalogItemGuid?: string;
    attachmentId?: number | undefined;
    exportFormat?: FormatId;
    source?: ExportSource;
    legacyCatalogItemId?: number | undefined;
    legacyExportOrderId?: number | undefined;
    legacyIncludeAttachments?: boolean | undefined;
    legacyExportEmail?: string | undefined;
}

export enum FormatId {
    Unknown = 1,
    Doc = 9,
    Docx = 10,
    Xlsx = 20,
    Rtf = 30,
    Pdf = 40,
    Text = 50,
    GaebXmlD80 = 100,
    GaebXmlD81 = 101,
    GaebXmlD82 = 102,
    GaebXmlD83 = 103,
    Gaeb90D81 = 110,
    Gaeb90D82 = 111,
    Gaeb90D83 = 112,
    Gaeb2000D81 = 115,
    Gaeb2000D82 = 116,
    Gaeb2000D83 = 117,
    Datanorm5ArticleListOnly = 120,
    ANormA2063TenderOffer = 130,
    ANormA2063CostEstimate = 131,
    OrcaGaebXmlD80 = 200,
    OrcaGaebXmlD81 = 201,
    OrcaGaebXmlD82 = 202,
    OrcaGaebXmlD83 = 203,
    DragAndDropOnlineDataXInternV1 = 210,
    DragAndDropOnlineDataXmlV1 = 211,
    CatalogItemLink = 212,
}

export enum ExportSource {
    Unknown = 0,
    CopyClipboard = 1,
    CopyClipboardSelected = 2,
    Export = 3,
    ExportDialog = 4,
    Viewer = 5,
}

export enum InterfaceType {
    Unknown = 0,
    ApiV1 = 1,
    ApiV2 = 2,
    WebV3 = 3,
    WebV4 = 4,
    IntegrationV2 = 5,
    ApiV3 = 6,
}

export interface TrackLoginRequestDto extends TrackBaseDto {
    source?: LoginSource;
    catalogKey?: string | undefined;
    catalogItemGuid?: string | undefined;
    attachmentId?: number | undefined;
    viewMode?: string | undefined;
}

export enum LoginSource {
    Unknown = 0,
    UserMenu = 1,
    UserMenuCatalogView = 2,
    ExportPositions = 3,
    Export = 4,
    Viewer = 5,
    OnBoard = 6,
    Watchlist = 7,
}

export interface TrackLoginSuccessDto extends TrackBaseDto {
    catalogKey?: string | undefined;
    professionGroup?: ProfessionGroupType;
    source?: LoginSource;
}

export enum ProfessionGroupType {
    None = 0,
    Architect = 1,
    CivilEngineer = 2,
    TechnicalPlanner = 3,
    BuildingTrade = 4,
    Retailer = 5,
    Student = 6,
    GeneralContractor = 7,
    CitiesMunicipality = 8,
    Private = 9,
    Other = 10,
    ProductManufacturer = 11,
}

export interface TrackSearchRelatedBaseDto extends TrackBaseDto {
    searchGuid?: string | undefined;
}

export interface TrackCatalogListingDto extends TrackSearchRelatedBaseDto {
    searchFilter?: string | undefined;
    catalogKeys?: string | undefined;
    source?: CatalogListingSource;
}

export enum CatalogListingSource {
    Startpage = 0,
    Az = 1,
    Categories = 2,
    SearchResult = 3,
    SearchSuggestions = 4,
    SearchResultCatalogList = 5,
    International = 6,
    LogoCarousel = 7,
    LogoWall = 8,
}

export interface TrackCatalogSuggestionDto extends TrackBaseDto {
    catalogKeys?: string | undefined;
    source?: CatalogSuggestionSource;
    searchFilter?: string | undefined;
}

export enum CatalogSuggestionSource {
    Startpage = 0,
    Az = 1,
    Categories = 2,
    SearchResult = 3,
    International = 4,
}

export interface TrackSearchResultRelatedBaseDto extends TrackSearchRelatedBaseDto {
    searchResultPage?: number | undefined;
    searchResultPosition?: number | undefined;
}

export interface TrackCatalogDto extends TrackSearchResultRelatedBaseDto {
    catalogKey?: string | undefined;
    isCatalogInformation?: boolean;
    catalogViewOrigin?: CatalogViewOrigin;
}

export enum CatalogViewOrigin {
    Other = 0,
    Az = 1,
    Category = 2,
    SearchResult = 3,
    SearchSuggestion = 4,
    SearchResultCatalogList = 5,
    LinkedCatalogs = 6,
    Administration = 7,
    LogoWall = 9,
    International = 10,
    LogoCarousel = 11,
}

export interface TrackCatalogItemDto extends TrackSearchResultRelatedBaseDto {
    catalogKey?: string | undefined;
    catalogItemGuid?: string;
    catalogViewOrigin?: CatalogViewOrigin;
}

export interface TrackAttachmentDto extends TrackBaseDto {
    catalogKey?: string | undefined;
    catalogItemGuid?: string;
    attachmentId?: number | undefined;
    isExplicitlyViewed?: boolean;
    isLargeViewer?: boolean;
    legacyAttachmentIsPicture?: boolean | undefined;
    legacyAttachmentIndex?: number | undefined;
    legacyAttachmentValue?: string | undefined;
}

export interface TrackSearchCatalogDto extends TrackSearchRelatedBaseDto {
    origin?: SearchOrigin;
    suggestionSource?: SearchSuggestionSource;
    catalogKey?: string | undefined;
    searchText?: string | undefined;
    searchFilter?: string | undefined;
    pageIndex?: number;
    pageSize?: number;
    countCatalogItems?: number;
}

export enum SearchOrigin {
    Startpage = 0,
    Az = 1,
    Category = 2,
    SearchResult = 3,
    Catalog = 4,
    International = 5,
    DirectApiAccess = 6,
}

export enum SearchSuggestionSource {
    None = 0,
    SearchTerm = 1,
    Catalog = 2,
    Category = 3,
    Startpage = 4,
    LinkedCatalog = 5,
}

export interface TrackSearchGlobalDto extends TrackSearchRelatedBaseDto {
    origin?: SearchOrigin;
    suggestionSource?: SearchSuggestionSource;
    searchText?: string | undefined;
    searchFilter?: string | undefined;
    pageIndex?: number;
    pageSize?: number;
    countCatalogItems?: number;
    countCatalogs?: number;
}

export interface TrackContactFormOpenDto extends TrackSearchRelatedBaseDto {
    catalogKey?: string | undefined;
    catalogItemGuid?: string | undefined;
    contactFormType?: number;
}

export interface TrackContactFormSubmitDto extends TrackSearchRelatedBaseDto {
    catalogKey?: string | undefined;
    catalogItemGuid?: string | undefined;
    salutation?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phone?: string | undefined;
    companyName?: string | undefined;
    message?: string | undefined;
    subject?: string | undefined;
    professionGroup?: number;
    contactFormType?: number;
    intentions?: ContactFormIntentions[] | undefined;
}

export enum ContactFormIntentions {
    ExpertAdvice = 1,
    CallBack = 2,
    ProductCatalog = 3,
    Prices = 4,
    PlanningDocuments = 5,
}

export interface TrackShareCatalogItemDto extends TrackBaseDto {
    catalogKey?: string | undefined;
    catalogItemGuid?: string | undefined;
    shareCatalogItemType?: ShareCatalogItemType;
}

export enum ShareCatalogItemType {
    Unknown = 0,
    CopyLink = 1,
    SendPerMail = 2,
}

export interface TrackCatalogExternalDto extends TrackBaseDto {
    catalogKey?: string | undefined;
    type?: CatalogExternalViewType;
    targetUrl?: string | undefined;
}

export enum CatalogExternalViewType {
    Unknown = 0,
    Email2 = 1,
    WebSite1 = 2,
    WebSite2 = 3,
    Facebook = 4,
    Instagram = 5,
    LinkedIn = 6,
    Pinterest = 7,
    Twitter = 8,
    Xing = 9,
    YouTube = 10,
}

export interface TrackLogoDownloadDto extends TrackBaseDto {
    catalogKey?: string | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}